export default __webpack_public_path__ + "static/media/oslo-badge-new.655248db.png";